import { render, staticRenderFns } from "./PRDeparttMent.vue?vue&type=template&id=c734a16c"
import script from "./PRDeparttMent.vue?vue&type=script&lang=js"
export * from "./PRDeparttMent.vue?vue&type=script&lang=js"
import style0 from "./PRDeparttMent.vue?vue&type=style&index=0&id=c734a16c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports